import Logging from '~app/core/logging';

function formatRecord(record) {
  return `${record.timestamp.toISOString()} ${Logging.levelToString(record.level)} ${record.loggerName} ${record.message}`;
}

export default function configureLogging() {
  if (process.env.NODE_ENV !== 'production') {
    Logging.configureLoggers({
      'root': {
        level: Logging.LOG_LEVELS.DEBUG,
        handlers: [
          new Logging.DebugHandler(formatRecord),
        ],
      },
      'app.actionLog': {
        level: Logging.LOG_LEVELS.TRACE,
      },
      'app.components': {
        level: Logging.LOG_LEVELS.DEBUG,
      },
    });
  }
  else {
    Logging.configureLoggers({
      'root': {
        level: Logging.LOG_LEVELS.WARN,
        handlers: [
          new Logging.StderrHandler(formatRecord),
        ],
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/configureLogging.js